// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loaders_loader__URlC-","mltShdSpin":"Loaders_mltShdSpin__3nteY","round":"Loaders_round__hDtIi"};